import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import excavatorTooth from "../../images/tooth.JPG";
import "../../../src/product.css";

const ExcavatorTooth = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">EXCAVATOR TIP</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={excavatorTooth}
              alt="Excavator Bucket Tooth"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              An excavator bucket tooth is a replaceable, heavy-duty metal tip
              attached to the front edge of an excavator bucket. It acts as a
              primary ground-engaging tool, concentrating the machine's
              hydraulic breakout force into a small surface area to pierce
              through tough materials such as packed dirt, clay, and rock.
            </p>

          </div>
        </section>

        {/* Specifications */}

        <section className="product-specifications">

          <div className="section-heading">
            <span>PRODUCT DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Product Type</span>
              <strong>Excavator Bucket Tooth</strong>
            </div>

            <div className="spec-card">
              <span>Application</span>
              <strong>Ground Engaging Tool</strong>
            </div>

            <div className="spec-card">
              <span>Material</span>
              <strong>Heavy-Duty Metal</strong>
            </div>

            <div className="spec-card">
              <span>Function</span>
              <strong>Digging &amp; Ground Penetration</strong>
            </div>

            <div className="spec-card">
              <span>Suitable For</span>
              <strong>Excavators</strong>
            </div>

            <div className="spec-card">
              <span>Replacement Type</span>
              <strong>Replaceable Tip</strong>
            </div>

            <div className="spec-card">
              <span>Available For</span>
              <strong>XCMG, HITACHI, DOOSAN, DEVELON, SANY, KOMATSU</strong>
            </div>

            <div className="spec-card">
              <span>Key Benefit</span>
              <strong>Reduced Bucket Wear</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default ExcavatorTooth;